/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { useState } from "react";
import { EvidencePart } from "@interfaces/Interfaces";
import "./EvidenceParts.css";
import { IonItem, IonRadio, IonRadioGroup } from "@ionic/react";
import { Text, View } from "@react-pdf/renderer";
import { getDisplayTitleForPDFExport } from "@utils/stringUtils";

type Props = {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  definition: EvidencePart;
  onValueChanged?: (value: any) => void;
  data?: any;
  isDisplay?: boolean;
  isPDF?: boolean;
  pdfStyles: any;
  initialValue?: any;
};

const ConfidenceScale: React.FC<Props> = ({
  definition,
  onValueChanged,
  data,
  isDisplay,
  isPDF,
  pdfStyles,
  initialValue,
}) => {
  const [value, setValue] = useState<string>(initialValue || "");
  const listValues: string[] = [
    ...Array(5)
      .fill(1)
      .map((_, i) => `${i + 1}`),
  ];

  const valueChanged = (event: any): void => {
    const _value = event.detail.value;

    setValue(_value);
    onValueChanged && onValueChanged(_value);
  };

  if (isPDF) {
    return (
      <View>
        <Text style={pdfStyles.reflectionHeader}>{getDisplayTitleForPDFExport(definition)}</Text>
        <Text style={pdfStyles.evidenceDate}>{data}</Text>
      </View>
    );
  }

  if (isDisplay) {
    return (
      <div className="readEvidenceBlock">
        <div className="readEvidenceHeader">{definition["Display Title"] || definition.Name}</div>
        <div className="readEvidenceText">{data}</div>
        <div className="h-[1px] w-full bg-grey-30 mt-4" />
      </div>
    );
  }

  return (
    <div>
      <IonRadioGroup
        color="light"
        id="editRoleRadioGroup"
        value={value}
        onIonChange={valueChanged}
      >
        {listValues.map((item) => {
          return (
            <div key={item}>
              <IonItem
                className="evidencePartsRadioContainer"
                key={item}
              >
                <IonRadio
                  aria-label={item}
                  mode="md"
                  value={item}
                  justify="space-between"
                  className={`text-17px tracking-[-0.3] ${value === item ? "font-semibold" : ""}`}
                >
                  {item}
                </IonRadio>
              </IonItem>
            </div>
          );
        })}
      </IonRadioGroup>
    </div>
  );
};

export default ConfidenceScale;
